import styled from 'styled-components'

const ReadonlyImageTextTitle = styled.p`
  font-size: ${p => p.theme.fonts.$p3};
  font-weight: ${p => p.theme.weights.$semiBold};
`

ReadonlyImageTextTitle.displayName = 'ReadonlyImageTextTitle'
export default ReadonlyImageTextTitle
